import { Menu as MenuAntd, Dropdown, Avatar } from "antd";

import { LogoutOutlined, ArrowLeftOutlined } from "@ant-design/icons";

import { useAuth } from "../../hooks/auth";

import { Container, Profile } from "./styles";

import logoSecretaria from "../../assets/logoBraco.png";

import BaseOndas from "../../assets/base-ondas.png";

import { useHistory } from "react-router-dom";

export default function NewHeader() {
  const history = useHistory();

  const { client, signOut, token } = useAuth();

  const { name, institution, image } = client || {};

  const { title } = institution || {};

  let nome = name;
  let user = nome;

  const arrayNome = (name || "").split(" ");

  if (arrayNome.length > 1) {
    nome = `${arrayNome[0]} ${arrayNome[arrayNome.length - 1]}`;
    user = `${arrayNome[0].substr(0, 1)}${arrayNome[
      arrayNome.length - 1
    ].substr(0, 1)}`;
  }

  const menu = (
    <MenuAntd>
      <MenuAntd.Item key="0" onClick={() => signOut()}>
        <span>
          <LogoutOutlined />
          Sair
        </span>
      </MenuAntd.Item>
    </MenuAntd>
  );

  return (
    <Container>
      <div className="appBar">
        <div
          className="loginContainer"
          onClick={() => {
            history.push("/login");
          }}
        >
          <ArrowLeftOutlined />
          <div className="login">Login</div>
        </div>
        {/* <img
          title="Voltar para o início"
          src={logoAppBar}
          alt="SSPDS"
          width="348"
          height="64"
        /> */}
        <Dropdown
          className="btnAvatarMobile"
          trigger={["click"]}
          overlay={menu}
        >
          <Avatar
            /* style={{
                          backgroundColor: "#f56a00",
                          verticalAlign: "middle",
                        }} */
            src={image}
            size="large"
          >
            {user}
          </Avatar>
        </Dropdown>
      </div>
      <header className="main">
        <div className="contain">
          <div style={{ display: "flex", cursor: "pointer" }}>
            <div className="imgLogo">
              <img
                onClick={() => {
                  history.push("/home");
                }}
                title="Voltar para o início"
                src={logoSecretaria}
                alt="SSPDS"
                width="348"
                height="64"
              />
            </div>

            {token && (
              <div className="profile">
                <aside>
                  <Profile>
                    <div className="nameUser">
                      <strong>{nome}</strong>
                      <small>{title}</small>
                    </div>
                    <Dropdown trigger={["click"]} overlay={menu}>
                      <Avatar
                        className="btnAvatar"
                        /* style={{
                          backgroundColor: "#f56a00",
                          verticalAlign: "middle",
                        }} */
                        src={image}
                        size="large"
                      >
                        {user}
                      </Avatar>
                    </Dropdown>
                  </Profile>
                </aside>
              </div>
            )}
          </div>

          <div className="header_content_menu">
            <div className="baseOndas">
              <img src={BaseOndas} alt="base-ondas" />
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div
                className="labelEco"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  justifyItems: "center",
                }}
              ></div>
            </div>
          </div>
        </div>
      </header>
    </Container>
  );
}
